import React from 'react';

import {AdminCompanyForm} from "./form";
import {BasicUpdateForm} from "../../utils/proto/mixins/form/update";




export const AdminCompanyEditForm =  AdminCompanyForm(BasicUpdateForm('company'));